import styles from './CasinoCardDescription.module.scss';

export type CasinoCardDescriptionProps = {
  produttore: string;
};

export const CasinoCardDescription = ({ produttore }: CasinoCardDescriptionProps) => {
  return <p className={styles.container}>{produttore}</p>;
};
